<template>
  <div class="content">
    <!-- Stats V2 -->
    <!-- bandeau masqué sur l'onglet PS, ce sont des compteurs de BDC -->
    <v-card
      v-if="stats && currentTab !== 'ps'"
      elevation="0"
      outlined
      :style="{ opacity: statsLoading ? 0.55 : 1, transition: 'opacity .15s' }"
    >
      <v-card-text>
        <!-- périmètre couvert par les chiffres du bandeau -->
        <div class="stats-scope">
          <v-icon x-small color="#888">mdi-filter-variant</v-icon>
          <span>{{ scopeLabel }}</span>
          <span v-if="statsStale" class="stats-stale">
            Chiffres non actualisés, le dernier chargement a échoué
          </span>
        </div>

        <div v-if="stats.truncated" class="stats-truncated">
          <v-icon small color="#c62828">mdi-alert-outline</v-icon>
          Résultats partiels : la recherche dépasse 200 correspondances. Les
          compteurs et les montants ne sont pas affichés tant qu'ils seraient
          faux. Affinez la saisie.
        </div>

        <template v-else>
          <div class="row">
            <div class="col">
              BDC V2 :
              <span style="color: black; font-weight: bold">{{
                stats.bdcTotal
              }}</span>
              <span v-if="refFor('bdcTotal')" class="stat-ref">
                sur {{ statsRef.bdcTotal }}
              </span>
              <br />
              Signés aujourd'hui :
              <span style="color: black; font-weight: bold">{{
                stats.bdcToday
              }}</span>
              <span v-if="refFor('bdcToday')" class="stat-ref">
                sur {{ statsRef.bdcToday }}
              </span>
              <br />
              V2 : <strong>{{ stats.nbV2 }}</strong> / V1V2 :
              <strong>{{ stats.nbV1V2 }}</strong>
            </div>
            <div class="col">
              Soumis ASP :
              <span style="color: black; font-weight: bold">{{
                stats.bdcSoumisAsp
              }}</span>
              <br />
              Rejetés :
              <span style="color: red; font-weight: bold">{{
                stats.bdcRejetes
              }}</span>
              <br />
              VA générées :
              <span style="color: black; font-weight: bold">{{
                stats.bdcVa
              }}</span>
            </div>
            <div class="col">
              PS actives :
              <span style="color: black; font-weight: bold">{{
                stats.psMonitoring
              }}</span>
              <br />
              PS prêtes :
              <span style="color: black; font-weight: bold">{{
                stats.psReady
              }}</span>
              <br />
              PS soumises :
              <span style="color: black; font-weight: bold">{{
                stats.psSubmitted
              }}</span>
            </div>
          </div>

          <v-divider style="margin: 10px 0"></v-divider>
          <div class="row">
            <div class="col">
              <div class="stat-label">TOTAL PRESTATION</div>
              <strong>{{ stats.totalPPHT }} € HT</strong>
              <span style="color: green; font-weight: bold; margin-left: 8px"
                >{{ stats.totalPPTTC }} € TTC</span
              >
              <div v-if="refFor('totalPPHT')" class="stat-ref">
                sur {{ statsRef.totalPPHT }} € HT{{ sharePercent }}
              </div>
            </div>
            <div class="col">
              <div class="stat-label">AVANCE (40%)</div>
              <strong>{{ stats.avanceHT }} € HT</strong>
              <span style="color: green; margin-left: 8px"
                >{{ stats.avanceTTC }} € TTC</span
              >
            </div>
            <div class="col">
              <div class="stat-label">SOLDE (60%)</div>
              <strong>{{ stats.soldeHT }} € HT</strong>
              <span style="color: green; margin-left: 8px"
                >{{ stats.soldeTTC }} € TTC</span
              >
            </div>
            <div class="col" v-if="stats.psEstimeHT > 0">
              <div class="stat-label">PREST. SECONDAIRE</div>
              <strong>{{ stats.psEstimeHT }} € HT</strong>
            </div>
          </div>

          <!-- montant moyen du périmètre -->
          <div v-if="stats.bdcTotal > 0" class="stat-average">
            Montant moyen : <strong>{{ averageHT }} € HT</strong> par BDC
          </div>
        </template>
      </v-card-text>
    </v-card>

    <!-- Recherche -->
    <md-card style="margin-bottom: 40px; margin-top: 10px">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-field>
            <label>Recherche multi-critères</label>
            <md-input v-on:keyup.enter="search" v-model="query"></md-input>
            <span class="md-helper-text"
              >Nom, RPPS, FINESS, raison sociale, email, téléphone, N° éditeur,
              N° ASP</span
            >
          </md-field>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select
            :items="sortOptions"
            v-model="sortBy"
            label="Trier par"
            @change="applySort()"
          ></v-select>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select
            :items="['Décroissant', 'Croissant']"
            v-model="sortOrder"
            label="Tri"
            @change="applySort()"
          ></v-select>
        </div>
        <div
          class="md-layout-item"
          style="margin-top: 7px"
          v-if="currentTab !== 'ps'"
        >
          <v-select
            :items="emailStatusFilterOptions"
            v-model="emailStatusFilter"
            label="Statut email"
            @change="search()"
          ></v-select>
        </div>
        <div
          class="md-layout-item"
          style="margin-top: 7px"
          v-if="currentTab !== 'ps'"
        >
          <v-select
            :items="partyTypeOptions"
            v-model="partyType"
            item-text="text"
            item-value="value"
            label="Type structure"
            @change="search()"
          ></v-select>
        </div>
      </div>

      <!-- filtres d'analyse -->
      <div class="md-layout filters-row-2" v-if="currentTab !== 'ps'">
        <div class="md-layout-item">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            offset-y
            min-width="330"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="periodLabel"
                label="Période de signature"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
                @click:clear="clearPeriod()"
              ></v-text-field>
            </template>
            <v-card>
              <v-card-text class="period-card">
                <div class="period-shortcuts">
                  <v-btn
                    v-for="s in periodShortcuts"
                    :key="s.key"
                    x-small
                    outlined
                    color="#e2007a"
                    @click="applyPeriodShortcut(s.key)"
                  >
                    {{ s.label }}
                  </v-btn>
                </div>
                <v-text-field
                  v-model="signedFrom"
                  label="Du"
                  type="date"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="signedTo"
                  label="Au"
                  type="date"
                  dense
                ></v-text-field>
                <div v-if="periodInvalid" class="period-error">
                  La date de début est postérieure à la date de fin.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn text x-small @click="clearPeriod()">Effacer</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  x-small
                  color="#e2007a"
                  :disabled="periodInvalid"
                  @click="applyPeriod()"
                >
                  Appliquer
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
        <div class="md-layout-item">
          <v-select
            :items="typePrestationOptions"
            v-model="typePrestation"
            item-text="text"
            item-value="value"
            label="Type de prestation"
            @change="search()"
          ></v-select>
        </div>
        <div class="md-layout-item">
          <v-select
            :items="trancheOptions"
            v-model="tranche"
            item-text="text"
            item-value="value"
            label="Tranche structure"
            @change="search()"
          ></v-select>
        </div>
        <div class="md-layout-item">
          <v-select
            :items="pilotOptions"
            v-model="pilot"
            item-text="text"
            item-value="value"
            label="Pilote"
            @change="search()"
          ></v-select>
        </div>
        <!-- colonne vide, les deux lignes de filtres ont ainsi la même grille -->
        <div class="md-layout-item"></div>
      </div>

      <div
        v-if="searchTruncated"
        style="font-size: 12px; color: #c62828; margin-top: 4px"
      >
        Plus de 200 résultats sur la recherche - affinez votre saisie pour ne
        rien manquer.
      </div>
      <div class="search-actions">
        <div class="search-actions-side"></div>
        <md-button class="md-prokov search-submit" @click="search()"
          >Rechercher</md-button
        >
        <div class="search-actions-side search-actions-right">
          <v-btn
            v-if="currentTab !== 'ps'"
            outlined
            small
            color="#e2007a"
            :loading="exporting"
            :disabled="searchTruncated"
            :title="
              searchTruncated
                ? 'Export impossible sur une recherche tronquée'
                : 'Exporter exactement ce qui est affiché'
            "
            @click="exportView()"
          >
            <v-icon small left>mdi-file-excel-outline</v-icon>
            Exporter la vue
          </v-btn>
        </div>
      </div>
      <button class="diagCloseButton" @click="clearSearch()">
        <md-icon>delete</md-icon>
      </button>
    </md-card>

    <!-- filtres actifs, retirables un par un -->
    <div v-if="activeFilterChips.length" class="active-filters">
      <v-chip
        v-for="chip in activeFilterChips"
        :key="chip.key"
        small
        close
        color="#e2007a"
        text-color="white"
        class="active-filter-chip"
        @click:close="removeFilter(chip.key)"
      >
        {{ chip.label }}
      </v-chip>
      <v-btn text x-small color="#e2007a" @click="clearSearch()">
        Tout effacer
      </v-btn>
    </div>

    <!-- Filtres -->
    <v-tabs
      v-model="currentTab"
      background-color="prokov"
      dark
      slider-color="white"
      slider-size="3"
      style="border-radius: 8px; margin-top: 10px"
    >
      <v-tab v-for="t in tabDefs" :key="t.key" :href="'#' + t.key">
        {{ t.label }}
        <span
          v-if="showBadge(t.key)"
          class="tab-badge"
          :class="{ 'tab-badge-empty': !tabCounts[t.key] }"
        >
          {{ tabCounts[t.key] }}
        </span>
      </v-tab>
    </v-tabs>

    <!-- Tableau BDC (tous les onglets sauf PS) -->
    <v-tabs-items v-model="currentTab" style="background: rgba(0, 0, 0, 0)">
      <v-tab-item
        v-for="t in tabDefs.filter((t) => t.key !== 'ps')"
        :key="t.key"
        :value="t.key"
      >
        <!-- En-tête corbeille : compteur + bouton Vider -->
        <div
          v-if="t.key === 'deleted'"
          style="
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 8px;
            background: #fff3e0;
            border-radius: 4px;
            margin: 8px 0;
          "
        >
          <v-icon color="orange darken-2">mdi-trash-can-outline</v-icon>
          <span style="font-size: 13px; flex: 1">
            <strong>{{ tabCounts.deleted || 0 }}</strong> BDC en corbeille
            <span v-if="filtersApplied && trashTotal !== tabCounts.deleted">
              sur {{ trashTotal }} au total
            </span>
            <span v-if="trashTotal" style="color: #888">
              (purge automatique après {{ trashTtlDays }} jours via cron 3h00)
            </span>
          </span>
          <v-btn
            color="red"
            small
            dark
            :disabled="!trashTotal"
            @click="openEmptyTrashDialog"
          >
            <v-icon x-small left>mdi-delete-empty-outline</v-icon>
            Vider la corbeille
          </v-btn>
        </div>
        <div style="width: 100%" class="md-layout">
          <md-table v-if="rows && rows.length" v-model="rows">
            <md-table-row
              slot="md-table-row"
              md-selectable="single"
              slot-scope="{ item }"
            >
              <md-table-cell md-label="Résident" v-if="item.resident">
                {{ item.resident.prénom }} {{ item.resident.nom }}
              </md-table-cell>

              <md-table-cell md-label="RPPS">
                <template v-if="item.msp">
                  <span :title="mspTooltip(item.msp)"
                    >F - {{ item.msp.FINESS }}</span
                  >
                  <div
                    v-if="item.msp.raisonSociale"
                    style="font-size: 11px; color: #666"
                  >
                    {{ item.msp.raisonSociale }}
                  </div>
                </template>
                <template v-else-if="item.resident"
                  >R - {{ item.resident.RPPS }}</template
                >
              </md-table-cell>

              <md-table-cell md-label="N° Éditeur">{{
                item.numeroEditeur
              }}</md-table-cell>

              <md-table-cell md-label="Type">
                <v-chip
                  v-if="item.typePrestation"
                  x-small
                  :color="typeColor(item.typePrestation)"
                  dark
                >
                  {{ item.typePrestation }}
                </v-chip>
                <span v-else-if="item.wave === 'V1'" style="font-size: 12px"
                  >V1</span
                >
                <span v-else>-</span>
              </md-table-cell>

              <md-table-cell md-label="Montant"
                >{{ item.montantSegurHT }} €</md-table-cell
              >

              <md-table-cell md-label="Date signature">
                {{ getDate(item.dateSignatureCommande || item.createdAt) }}
              </md-table-cell>

              <md-table-cell md-label="État">
                <v-chip x-small :color="stateColor(item.state)" dark>{{
                  stateLabel(item.state)
                }}</v-chip>
                <v-chip
                  v-if="item.awaitingFirstSign"
                  x-small
                  color="blue"
                  dark
                  class="mt-1"
                >
                  En attente signature
                </v-chip>
              </md-table-cell>

              <md-table-cell
                md-label="Pilote"
                v-if="currentTab !== 'archivesV1'"
              >
                <v-chip
                  v-if="item.isPilot"
                  x-small
                  :color="pilotColor(item.pilotStatus)"
                  dark
                >
                  {{ pilotLabel(item.pilotStatus) }}
                </v-chip>
                <span v-else style="color: #ccc">-</span>
              </md-table-cell>

              <md-table-cell
                md-label="Email"
                v-if="currentTab !== 'archivesV1'"
              >
                <v-tooltip
                  bottom
                  :disabled="item.emailStatus !== 'FAILED' || !item.emailError"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      x-small
                      :color="emailStatusColor(item.emailStatus)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ emailStatusLabel(item.emailStatus) }}
                    </v-chip>
                  </template>
                  <span>{{ item.emailError }}</span>
                </v-tooltip>
              </md-table-cell>

              <md-table-cell md-label="N° ASP">{{
                item.numeroASP || "-"
              }}</md-table-cell>

              <md-table-cell md-label="VA">
                <v-chip
                  v-if="item.files && item.files.vaPDF"
                  color="green"
                  x-small
                  dark
                  >Oui</v-chip
                >
                <v-chip v-else color="red" x-small dark>Non</v-chip>
              </md-table-cell>

              <md-table-cell md-label="PS" v-if="currentTab !== 'archivesV1'">
                <v-chip
                  v-if="item.ps"
                  x-small
                  :color="psColor(item.ps.status)"
                  dark
                >
                  {{ item.ps.status }}
                </v-chip>
                <span v-else>-</span>
              </md-table-cell>

              <template v-if="currentTab === 'mustResign'">
                <md-table-cell md-label="Marqué le">
                  {{ item.resignMarkedAt ? getDate(item.resignMarkedAt) : "-" }}
                </md-table-cell>
                <md-table-cell md-label="Marqué par">
                  {{ item.resignMarkedBy || "-" }}
                </md-table-cell>
              </template>

              <template v-if="currentTab === 'rejetes'">
                <md-table-cell md-label="Code">{{
                  item.codeTraitement
                }}</md-table-cell>
                <md-table-cell md-label="Libellé">{{
                  item.libelleTraitement
                }}</md-table-cell>
              </template>

              <template v-if="currentTab === 'deleted'">
                <md-table-cell md-label="Supprimé le">
                  {{ getDate(item.deletedAt) }}
                </md-table-cell>
                <md-table-cell md-label="Purge">
                  <v-chip
                    x-small
                    :color="purgeColor(item.purgeScheduledAt)"
                    dark
                  >
                    {{ purgeLabel(item.purgeScheduledAt) }}
                  </v-chip>
                </md-table-cell>
              </template>

              <md-table-cell md-label="">
                <v-btn
                  class="mx-2"
                  icon
                  small
                  color="teal"
                  @click="openDetail(item)"
                >
                  <v-icon dark>mdi-format-list-bulleted-square</v-icon>
                </v-btn>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div v-else style="padding: 20px; text-align: center; color: #999">
            Aucun bon de commande
          </div>
        </div>

        <div class="text-center" style="margin-top: 10px">
          <v-pagination
            :value="page"
            @input="onPageChange"
            :length="pageCount"
          ></v-pagination>
        </div>
      </v-tab-item>

      <!-- Onglet Prestation Secondaire (tableau dédié) -->
      <v-tab-item key="ps" value="ps">
        <div
          style="
            display: flex;
            gap: 24px;
            align-items: center;
            flex-wrap: wrap;
            padding: 8px 4px;
            font-size: 11px;
            color: #888;
          "
        >
          <span
            >PERF :
            <span style="color: green">● ≥60% = 1.0</span>
            <span style="color: orange; margin-left: 6px">● 40-59% = 0.5</span>
            <span style="color: red; margin-left: 6px">● &lt;40% = 0</span>
          </span>
          <span style="border-left: 1px solid #ddd; padding-left: 12px">
            <strong>Dt</strong> docs attendus
            <strong style="margin-left: 8px">Dm</strong> docs envoyés
            <strong style="margin-left: 8px">T</strong> patients
            <strong style="margin-left: 8px">Tq</strong> INS qualifiée
            <strong style="margin-left: 8px">Ts</strong> INS transitoire
          </span>
        </div>
        <div style="width: 100%" class="md-layout">
          <div v-if="psError" class="ps-error">
            <v-icon small color="#c62828">mdi-alert-outline</v-icon>
            Les prestations secondaires n'ont pas pu être chargées. Le tableau
            ci-dessous peut être incomplet ou périmé.
          </div>
          <md-table v-if="psRows && psRows.length" v-model="psRows">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Résident" v-if="item.resident">
                {{ item.resident.prénom }} {{ item.resident.nom }}
              </md-table-cell>

              <md-table-cell md-label="RPPS" v-if="item.resident">
                {{ item.resident.RPPS }}
              </md-table-cell>

              <md-table-cell md-label="N° Éditeur">{{
                item.numeroEditeur
              }}</md-table-cell>

              <md-table-cell md-label="Début">{{
                item.dateDebut
              }}</md-table-cell>
              <md-table-cell md-label="Fin">{{ item.dateFin }}</md-table-cell>

              <md-table-cell md-label="Status">
                <v-chip x-small :color="psColor(item.status)" dark>{{
                  item.status
                }}</v-chip>
              </md-table-cell>

              <md-table-cell md-label="PERF">
                <strong
                  v-if="item.perfCoefficient != null"
                  :style="{
                    color:
                      item.perfCoefficient >= 1
                        ? 'green'
                        : item.perfCoefficient > 0
                        ? 'orange'
                        : 'red',
                  }"
                >
                  {{ item.perfCoefficient }}
                </strong>
                <strong
                  v-else
                  :style="{
                    color:
                      item.dmDtRatio >= 60
                        ? 'green'
                        : item.dmDtRatio >= 40
                        ? 'orange'
                        : 'red',
                  }"
                >
                  {{
                    item.dmDtRatio >= 60
                      ? "1.0"
                      : item.dmDtRatio >= 40
                      ? "0.5"
                      : "0"
                  }}
                </strong>
              </md-table-cell>

              <md-table-cell md-label="Progression" style="min-width: 140px">
                <div style="display: flex; align-items: center; gap: 8px">
                  <v-progress-linear
                    :value="item.dmDtRatio"
                    :color="
                      item.dmDtRatio >= 60
                        ? 'green'
                        : item.dmDtRatio >= 40
                        ? 'orange'
                        : 'red'
                    "
                    height="12"
                    rounded
                    style="max-width: 80px"
                  ></v-progress-linear>
                  <span style="font-size: 12px; font-weight: bold"
                    >{{ item.dmDtRatio }}%</span
                  >
                </div>
              </md-table-cell>

              <md-table-cell md-label="Dt">{{ item.dt }}</md-table-cell>
              <md-table-cell md-label="Dm">{{ item.dm }}</md-table-cell>
              <md-table-cell md-label="T">{{ item.t }}</md-table-cell>
              <md-table-cell md-label="Tq">{{ item.tq }}</md-table-cell>
              <md-table-cell md-label="Ts">{{ item.ts }}</md-table-cell>
            </md-table-row>
          </md-table>
          <div v-else style="padding: 20px; text-align: center; color: #999">
            Aucune prestation secondaire
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <!-- Détail dialog -->
    <v-dialog v-model="dialog" width="900" @input="onDialogToggle">
      <v-card v-if="selectedItem">
        <v-card-title class="text-h5 grey lighten-2">
          {{
            selectedItem.resident
              ? selectedItem.resident.prénom + " " + selectedItem.resident.nom
              : "BDC"
          }}
          <v-spacer></v-spacer>
          <!-- En attente / Re-signé / Nominal selon mustResign + resignMarkedAt -->
          <v-chip
            v-if="selectedItem.mustResign"
            small
            color="orange darken-2"
            dark
            class="ml-2"
            title="En attente de signature du médecin"
          >
            <v-icon left small>mdi-clock-alert-outline</v-icon>
            En attente de re-signature
          </v-chip>
          <v-chip
            v-else-if="selectedItem.resignMarkedAt"
            small
            color="green darken-1"
            dark
            class="ml-2"
            title="BDC re-signé par le médecin après correction admin"
          >
            <v-icon left small>mdi-check-decagram</v-icon>
            Re-signé après correction
          </v-chip>
        </v-card-title>
        <v-card-text v-if="editMode">
          <!-- Mode edition : EditableBdcCard -->
          <editable-bdc-card
            :bdc="selectedItem"
            @save="onEditableSave"
            @cancel="cancelEditMode"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-col cols="12">
            <h4>BON DE COMMANDE</h4>
            <div style="color: blue; margin-left: 10px; margin-top: 10px">
              ID : {{ selectedItem.id }}<br />
              N° éditeur : {{ selectedItem.numeroEditeur }} / N° ASP :
              {{ selectedItem.numeroASP || "-" }}<br />
              Montant HT : {{ selectedItem.montantSegurHT }} € / Type :
              {{ selectedItem.typePrestation }}<br />
              État : {{ selectedItem.state }} / Wave : {{ selectedItem.wave
              }}<br />
              Partenaire : {{ selectedItem.partnerCode }}<br />
              <span v-if="selectedItem.isPilot">
                Pilote :
                <v-chip
                  x-small
                  :color="pilotColor(selectedItem.pilotStatus)"
                  dark
                  >{{ pilotLabel(selectedItem.pilotStatus) }}</v-chip
                ><br />
              </span>
              Email BDC :
              <v-tooltip bottom :disabled="!selectedItem.emailError">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    :color="emailStatusColor(selectedItem.emailStatus)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ emailStatusLabel(selectedItem.emailStatus) }}
                  </v-chip>
                </template>
                <span>{{ selectedItem.emailError }}</span>
              </v-tooltip>
              <br />
              <span v-if="selectedItem.resignMarkedAt">
                Re-signature :
                <v-chip
                  v-if="selectedItem.mustResign"
                  x-small
                  color="orange darken-2"
                  dark
                  >En attente médecin</v-chip
                >
                <v-chip v-else x-small color="green darken-1" dark
                  >Re-signé</v-chip
                >
                - marqué le
                <strong>{{ getDate(selectedItem.resignMarkedAt) }}</strong>
                <span v-if="selectedItem.resignMarkedBy">
                  par <strong>{{ selectedItem.resignMarkedBy }}</strong>
                </span>
                <span
                  v-if="selectedItem.resignReason"
                  style="color: #555; font-style: italic"
                >
                  - motif : {{ selectedItem.resignReason }}
                </span>
                <br />
              </span>
              <br />
              <div
                style="display: flex; gap: 8px; flex-wrap: wrap; margin: 4px 0"
              >
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.orderFormPDF"
                  x-small
                  color="primary"
                  @click="downloadPdf('bdc', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> BDC
                </v-btn>
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.vaPDF"
                  x-small
                  color="green"
                  dark
                  @click="downloadPdf('va', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> VA
                </v-btn>
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.invoicePDF"
                  x-small
                  color="orange"
                  dark
                  @click="downloadPdf('fac', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> Facture
                </v-btn>
                <v-btn
                  v-if="selectedItem.files && selectedItem.files.momPDF"
                  x-small
                  color="grey"
                  dark
                  @click="downloadPdf('mom', selectedItem.id)"
                >
                  <v-icon x-small left>mdi-download</v-icon> MOM
                </v-btn>
                <span
                  v-if="
                    !(
                      selectedItem.files &&
                      (selectedItem.files.orderFormPDF ||
                        selectedItem.files.vaPDF ||
                        selectedItem.files.invoicePDF ||
                        selectedItem.files.momPDF)
                    )
                  "
                  style="color: #999"
                >
                  Aucun PDF disponible
                </span>
              </div>

              <!-- rattachement d'un BDC papier signé, visibilité décidée par le backend -->
              <div
                v-if="canAddBdc"
                style="
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  flex-wrap: wrap;
                  margin: 4px 0;
                "
              >
                <v-btn
                  x-small
                  color="primary"
                  outlined
                  :loading="uploadingBdc"
                  :disabled="uploadingBdc"
                  @click="triggerBdcFilePicker"
                >
                  <v-icon x-small left>mdi-file-upload-outline</v-icon>
                  {{ hasBdcPdf ? "Remplacer le BDC" : "Ajouter un BDC" }}
                </v-btn>
                <span style="color: #999; font-size: 12px">
                  PDF signé, 3 Mo maximum
                </span>
              </div>
              <!-- input natif, le v-file-input ajouterait un champ texte et un clic -->
              <input
                ref="bdcFileInput"
                type="file"
                accept="application/pdf,.pdf"
                style="display: none"
                @change="onBdcFileSelected"
              />
              <div
                v-if="bdcUploadFeedback"
                :style="{
                  color: bdcUploadFeedback.success ? 'green' : 'red',
                  fontSize: '13px',
                  margin: '4px 0',
                }"
              >
                {{ bdcUploadFeedback.message }}
              </div>
              <br />
              <span v-if="selectedItem.codeTraitement" style="color: green">
                Retour ASP : {{ selectedItem.codeTraitement }} /
                {{ selectedItem.libelleTraitement }}<br />
              </span>
            </div>

            <div v-if="selectedItem.resident" style="margin-top: 20px">
              <h4>RÉSIDENT</h4>
              <div style="color: blue; margin-left: 10px; margin-top: 10px">
                {{ selectedItem.resident.nom }} {{ selectedItem.resident.prénom
                }}<br />
                RPPS : {{ selectedItem.resident.RPPS }}<br />
                Email : {{ selectedItem.resident.email }}<br />
                Tél : {{ selectedItem.resident.phone }}<br />
              </div>
            </div>

            <div v-if="selectedItem.msp" style="margin-top: 20px">
              <h4>MSP</h4>
              <div style="color: blue; margin-left: 10px; margin-top: 10px">
                FINESS : {{ selectedItem.msp.FINESS }}<br />
                <template v-if="selectedItem.msp.partnerRef">
                  Réf. interne : {{ selectedItem.msp.partnerRef }}<br />
                </template>
              </div>
            </div>

            <div v-if="selectedItem.ps" style="margin-top: 20px">
              <h4>PRESTATION SECONDAIRE</h4>
              <div style="color: blue; margin-left: 10px; margin-top: 10px">
                Status : {{ selectedItem.ps.status }}<br />
                PERF :
                {{
                  selectedItem.ps.perfCoefficient != null
                    ? selectedItem.ps.perfCoefficient
                    : "-"
                }}<br />
                Période : {{ selectedItem.ps.dateDebut }} au
                {{ selectedItem.ps.dateFin }}<br />
                Dt : {{ selectedItem.ps.dt }} / Dm : {{ selectedItem.ps.dm
                }}<br />
              </div>
            </div>
          </v-col>
        </v-card-text>
        <v-divider v-if="!editMode"></v-divider>
        <v-card-actions v-if="editMode">
          <v-spacer></v-spacer>
          <span style="font-size: 12px; color: #666; margin-right: 12px">
            Édition en cours - utilisez les boutons du formulaire pour
            enregistrer ou annuler
          </span>
        </v-card-actions>
        <v-card-actions v-else>
          <!-- BDC en corbeille : seul Restaurer est dispo (les autres actions sont contextuelles) -->
          <v-btn
            v-if="
              selectedItem &&
              selectedItem.deletedAt &&
              selectedItem.wave !== 'V1'
            "
            x-small
            color="green"
            dark
            @click="restoreBDC(selectedItem)"
          >
            <v-icon x-small left>mdi-restore</v-icon>
            Restaurer
          </v-btn>

          <!-- Édition V2 : déclenche la re-signature médecin via PATCH -->
          <template
            v-if="
              selectedItem &&
              !selectedItem.deletedAt &&
              selectedItem.wave === 'V2'
            "
          >
            <v-btn x-small color="#e2007a" dark @click="enterEditMode">
              <v-icon x-small left>mdi-pencil-outline</v-icon>
              Modifier
            </v-btn>
          </template>

          <!-- Mise en corbeille : V2 uniquement, BDC actif (pas déjà supprimé) -->
          <v-btn
            v-if="
              selectedItem &&
              !selectedItem.deletedAt &&
              selectedItem.wave !== 'V1'
            "
            x-small
            color="red"
            dark
            @click="showDeleteConfirmDialog = true"
          >
            <v-icon x-small left>mdi-delete-outline</v-icon>
            Supprimer
          </v-btn>

          <!-- Actions pilotes : indisponibles en mode corbeille -->
          <template v-if="selectedItem && !selectedItem.deletedAt">
            <v-btn
              v-if="!selectedItem.isPilot && selectedItem.state !== 'OFF'"
              x-small
              color="purple"
              dark
              @click="togglePilot(selectedItem, true)"
            >
              Marquer pilote
            </v-btn>
            <v-btn
              v-if="
                selectedItem.isPilot && selectedItem.pilotStatus !== 'VALIDATED'
              "
              x-small
              color="grey"
              dark
              @click="togglePilot(selectedItem, false)"
            >
              Retirer pilote
            </v-btn>
            <v-btn
              v-if="selectedItem.isPilot && selectedItem.pilotStatus === 'NONE'"
              x-small
              color="orange"
              dark
              @click="updatePilotStatus(selectedItem, 'SUBMITTED')"
            >
              Soumis ASP
            </v-btn>
            <v-btn
              v-if="
                selectedItem.isPilot && selectedItem.pilotStatus === 'SUBMITTED'
              "
              x-small
              color="green"
              dark
              @click="updatePilotStatus(selectedItem, 'VALIDATED')"
            >
              Valide ASP
            </v-btn>
            <v-btn
              v-if="
                selectedItem.isPilot && selectedItem.pilotStatus === 'SUBMITTED'
              "
              x-small
              color="red"
              dark
              @click="updatePilotStatus(selectedItem, 'REJECTED')"
            >
              Rejete ASP
            </v-btn>
            <v-btn
              x-small
              color="primary"
              dark
              @click="openResendEmailDialog(selectedItem)"
            >
              <v-icon x-small left>mdi-email-send-outline</v-icon>
              Re-envoyer email
            </v-btn>
          </template>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDetailDialog">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modale confirmation correction + re-signature -->
    <confirm-resign-modal
      :value="showConfirmResign"
      :bdc="selectedItem"
      :diff="pendingDiff"
      :resign-reason="pendingResignReason"
      :loading="patchLoading"
      @input="showConfirmResign = $event"
      @update:resign-reason="pendingResignReason = $event"
      @confirm="confirmPatch"
      @cancel="cancelPatch"
    />

    <!-- Dialog de mise en corbeille du BDC -->
    <v-dialog v-model="showDeleteConfirmDialog" persistent max-width="460">
      <v-card>
        <v-card-title class="headline" style="color: #d32f2f">
          <v-icon left color="red">mdi-trash-can-outline</v-icon>
          Placer le BDC en corbeille ?
        </v-card-title>
        <v-card-text style="font-size: 13px">
          Le bon de commande sera
          <strong>récupérable pendant {{ trashTtlDays }} jours</strong>
          depuis l'onglet Corbeille. Il sera ensuite supprimé définitivement
          (PDFs et données de suivi PS inclus).
          <div
            style="
              background: #f5f5f5;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
            "
          >
            <template v-if="selectedItem">
              N° Éditeur : <strong>{{ selectedItem.numeroEditeur }}</strong
              ><br />
              <template v-if="selectedItem.resident">
                Praticien :
                <strong
                  >{{ selectedItem.resident.prénom }}
                  {{ selectedItem.resident.nom }}</strong
                ><br />
                RPPS : {{ selectedItem.resident.RPPS }}<br />
              </template>
              <template v-if="selectedItem.msp">
                FINESS : {{ selectedItem.msp.FINESS }}<br />
                <template v-if="selectedItem.msp.partnerRef">
                  Réf. interne : {{ selectedItem.msp.partnerRef }}<br />
                </template>
              </template>
              Montant HT : <strong>{{ selectedItem.montantSegurHT }} €</strong
              ><br />
              État : <strong>{{ selectedItem.state }}</strong
              ><br />
              Wave : <strong>{{ selectedItem.wave }}</strong>
            </template>
          </div>
          Le médecin (résident) et la structure (MSP) ne sont pas supprimés : un
          nouveau BDC peut être créé pour ce praticien.
          <div
            class="mt-4"
            style="font-size: 12px; color: #555; margin-bottom: 6px"
          >
            Tapez <strong>SUPPRIMER</strong> en majuscules pour activer le
            bouton :
          </div>
          <v-text-field
            v-model="deleteConfirmText"
            placeholder="SUPPRIMER"
            dense
            outlined
            hide-details
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelDeleteBDC">Annuler</v-btn>
          <v-btn
            :color="canConfirmDelete ? 'red' : 'grey lighten-1'"
            :dark="canConfirmDelete"
            :disabled="!canConfirmDelete"
            @click="confirmDeleteBDC"
          >
            <v-icon left small>mdi-trash-can-outline</v-icon>
            Envoyer en corbeille
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- la cible est figée au choix du fichier (pas relue sur selectedItem) -->
    <v-dialog v-model="showBdcUploadConfirm" persistent max-width="460">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="primary">mdi-file-upload-outline</v-icon>
          Rattacher ce BDC signé ?
        </v-card-title>
        <v-card-text style="font-size: 13px">
          <template v-if="pendingBdcTarget">
            N° Éditeur : <strong>{{ pendingBdcTarget.numeroEditeur }}</strong
            ><br />
            <span v-if="pendingBdcTarget.label"
              >{{ pendingBdcTarget.label }}<br
            /></span>
            Fichier :
            <strong>{{ pendingBdcFile && pendingBdcFile.name }}</strong>
          </template>
          <div class="mt-3" style="color: #d32f2f">
            Le BDC passera à l'état Signé. Revenir en arrière imposera une
            demande de re-signature électronique au médecin.
          </div>
          <div
            v-if="pendingBdcTarget && pendingBdcTarget.hadPdf"
            class="mt-2"
            style="color: #d32f2f"
          >
            Un PDF est déjà attaché : il sera remplacé.
          </div>
          <div
            v-if="bdcConfirmError"
            class="mt-3"
            style="color: #d32f2f; font-weight: 500"
          >
            {{ bdcConfirmError }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="bdcConfirmError"
            small
            text
            color="primary"
            :disabled="uploadingBdc"
            @click="triggerBdcFilePicker"
          >
            Choisir un autre fichier
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            :disabled="uploadingBdc"
            @click="cancelBdcUpload"
          >
            Annuler
          </v-btn>
          <v-btn
            color="primary"
            :loading="uploadingBdc"
            :disabled="uploadingBdc"
            @click="confirmBdcUpload"
          >
            <v-icon left small>mdi-check</v-icon>
            Ajouter le BDC
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de vidage manuel de la corbeille (action opérateur) -->
    <v-dialog v-model="showEmptyTrashDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline" style="color: #d32f2f">
          <v-icon left color="red">mdi-delete-empty-outline</v-icon>
          Vider la corbeille ?
        </v-card-title>
        <v-card-text style="font-size: 13px">
          <strong>Action irréversible</strong> : tous les BDC en corbeille
          seront immédiatement supprimés définitivement (PDFs, données de suivi
          PS et BDC).
          <div
            style="
              background: #ffebee;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
              color: #c62828;
            "
          >
            <v-icon small color="red darken-2" left>mdi-alert-outline</v-icon>
            <strong>{{ trashTotal }}</strong> BDC seront purgés.
            <div
              v-if="filtersApplied"
              style="font-size: 12px; margin-top: 6px; font-weight: bold"
            >
              Le vidage ignore les filtres en cours : la corbeille est purgée en
              entier, pas seulement les {{ tabCounts.deleted || 0 }} BDC
              affichés.
            </div>
          </div>
          <div
            class="mt-4"
            style="font-size: 12px; color: #555; margin-bottom: 6px"
          >
            Tapez <strong>VIDER</strong> en majuscules pour activer le bouton :
          </div>
          <v-text-field
            v-model="emptyTrashConfirmText"
            placeholder="VIDER"
            dense
            outlined
            hide-details
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelEmptyTrash">Annuler</v-btn>
          <v-btn
            :color="canConfirmEmptyTrash ? 'red' : 'grey lighten-1'"
            :dark="canConfirmEmptyTrash"
            :disabled="!canConfirmEmptyTrash"
            @click="confirmEmptyTrash"
          >
            <v-icon left small>mdi-delete-forever</v-icon>
            Vider définitivement
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de conflit a la restauration : un BDC actif existe déjà (RPPS / FINESS) -->
    <v-dialog
      :value="!!restoreConflict"
      persistent
      max-width="500"
      @input="cancelRestoreSwap"
    >
      <v-card v-if="restoreConflict">
        <v-card-title class="headline" style="color: #f57c00">
          <v-icon left color="orange darken-2">mdi-swap-horizontal</v-icon>
          Conflit de restauration
        </v-card-title>
        <v-card-text style="font-size: 13px">
          Un BDC actif existe déjà pour ce
          <strong v-if="restoreConflict.type === 'STRUCTURE'"
            >établissement</strong
          >
          <strong v-else>praticien</strong>.
          <div
            style="
              background: #fff3e0;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
            "
          >
            <strong>BDC actif concurrent</strong><br />
            N° Éditeur : <strong>{{ restoreConflict.numeroEditeur }}</strong
            ><br />
            <template v-if="restoreConflict.RPPS">
              Praticien :
              <strong
                >{{ restoreConflict.prénom }} {{ restoreConflict.nom }}</strong
              ><br />
              RPPS : {{ restoreConflict.RPPS }}<br />
            </template>
            <template v-if="restoreConflict.FINESS">
              FINESS : {{ restoreConflict.FINESS }}<br />
            </template>
            État : {{ restoreConflict.state }}
          </div>
          <strong>Échanger</strong> : envoie le BDC actif ci-dessus en corbeille
          puis restaure le BDC sélectionné. Action transactionnelle, tracée dans
          l'audit.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelRestoreSwap">Annuler</v-btn>
          <v-btn color="orange darken-2" dark @click="confirmRestoreSwap">
            <v-icon left small>mdi-swap-horizontal</v-icon>
            Échanger
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de re-envoi du BDC sur une adresse email alternative -->
    <v-dialog v-model="showResendEmailDialog" max-width="460">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="primary">mdi-email-send-outline</v-icon>
          Re-envoyer le bon de commande
        </v-card-title>
        <v-card-text style="font-size: 13px">
          Le BDC sera renvoyé à l'adresse saisie ci-dessous. Le statut d'envoi
          sera mis à jour.
          <div
            v-if="selectedItem"
            style="
              background: #f5f5f5;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
            "
          >
            N° Éditeur : <strong>{{ selectedItem.numeroEditeur }}</strong
            ><br />
            <template v-if="selectedItem.resident">
              Praticien :
              <strong
                >{{ selectedItem.resident.prénom }}
                {{ selectedItem.resident.nom }}</strong
              ><br />
              Email enregistré : {{ selectedItem.resident.email || "-" }}
            </template>
          </div>
          <v-text-field
            v-model="resendEmailInput"
            label="Adresse email destinataire"
            type="email"
            placeholder="exemple@domaine.fr"
            outlined
            dense
            autofocus
            :disabled="resendEmailLoading"
          ></v-text-field>
          <v-checkbox
            v-model="resendEmailUpdateResident"
            label="Sauvegarder cette adresse en base (remplace l'email du résident pour tous ses BDC)"
            :disabled="resendEmailLoading || !canUpdateResidentEmail"
            hide-details
            dense
          ></v-checkbox>
          <div
            v-if="resendEmailFeedback"
            :style="{
              color: resendEmailFeedback.success ? 'green' : 'red',
              fontSize: '12px',
            }"
          >
            {{ resendEmailFeedback.message }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            :disabled="resendEmailLoading"
            @click="closeResendEmailDialog"
            >Annuler</v-btn
          >
          <v-btn
            color="primary"
            :loading="resendEmailLoading"
            :disabled="!isValidResendEmail || resendEmailLoading"
            @click="confirmResendEmail"
          >
            <v-icon left small>mdi-send</v-icon>
            Envoyer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import server from "@/store/server";
import EditableBdcCard from "@/components/Segur/EditableBdcCard.vue";
import ConfirmResignModal from "@/components/Segur/ConfirmResignModal.vue";

const API_BASE = server.url;
const PAGE_SIZE = 50;
const SEARCH_DEBOUNCE_MS = 400;
// même règle que rules.pdfSize de Segurbon.vue
const MAX_BDC_PDF_SIZE = 3 * 1024 * 1024;

export default {
  name: "SegurV2",
  components: {
    EditableBdcCard,
    ConfirmResignModal,
  },
  data() {
    return {
      stats: null,
      // même onglet sans les filtres, null si aucun filtre n'est actif
      scope: null,
      filtersApplied: false,
      statsLoading: false,
      // bandeau périmé après un appel en échec
      statsStale: false,
      // seule la réponse de la requête la plus récente est retenue
      reqSeq: 0,
      skipQueryWatch: false,
      // corbeille entière, ce que le vidage détruira
      trashTotal: 0,
      // périmètre décrit par le bandeau, figé au moment où ses chiffres sont appliqués
      appliedTab: "all",
      appliedFilterCount: 0,
      // périmètre auquel correspondent les chiffres affichés
      appliedStatsKey: null,
      psError: false,
      searchTimer: null,
      apiBase: API_BASE,
      rows: [],
      psRows: [],
      totalCount: 0,
      tabCounts: {},
      currentTab: "all",
      query: "",
      sortBy: "N° Éditeur",
      sortOrder: "Décroissant",
      sortOptions: ["N° Éditeur", "N° ASP", "Montant", "Date", "État"],
      emailStatusFilter: "Tous",
      emailStatusFilterOptions: [
        "Tous",
        "Envoyé",
        "Échec",
        "En cours",
        "Non suivi",
      ],
      partyType: "all",
      // filtres d'analyse
      typePrestation: "all",
      typePrestationOptions: [
        { text: "Tous", value: "all" },
        { text: "V2 seul", value: "V2" },
        { text: "V1V2", value: "V1V2" },
      ],
      tranche: "all",
      trancheOptions: [
        { text: "Toutes", value: "all" },
        { text: "A", value: "A" },
        { text: "B", value: "B" },
        { text: "C", value: "C" },
        { text: "D", value: "D" },
        { text: "E", value: "E" },
        { text: "Sans tranche (libéral)", value: "none" },
      ],
      pilot: "all",
      pilotOptions: [
        { text: "Tous", value: "all" },
        { text: "Pilotes", value: "yes" },
        { text: "Hors pilotes", value: "no" },
      ],
      signedFrom: null,
      signedTo: null,
      dateMenu: false,
      exporting: false,
      partyTypeOptions: [
        { text: "Tous", value: "all" },
        { text: "MSP uniquement", value: "msp" },
        { text: "Libéral uniquement", value: "liberal" },
      ],
      searchTruncated: false,
      page: 1,
      dialog: false,
      selectedItem: null,
      showDeleteConfirmDialog: false,
      deleteConfirmText: "",
      showResendEmailDialog: false,
      resendEmailInput: "",
      resendEmailLoading: false,
      resendEmailFeedback: null,
      resendEmailUpdateResident: false,
      // Corbeille SEGUR V2
      trashTtlDays: 30, // Surcharge par /segur/v2/orderforms (top-level)
      showEmptyTrashDialog: false,
      emptyTrashConfirmText: "",
      restoreConflict: null, // { id, numeroEditeur, RPPS, FINESS, type } recu en 409
      restoreConflictFor: null, // BDC qu'on essaie de restaurer (pour reprendre l'échange)

      editMode: false,
      pendingDiff: {},
      pendingResignReason: "",
      showConfirmResign: false,
      patchLoading: false,

      // Ajout d'un BDC papier signé depuis la modale d'options
      uploadingBdc: false,
      bdcUploadFeedback: null, // { success, message } affiché dans la modale
      bdcConfirmError: null, // erreur 400 affichée dans la confirmation
      showBdcUploadConfirm: false,
      pendingBdcFile: null,
      pendingBdcTarget: null, // { id, numeroEditeur, label, hadPdf }
      lockedBdcIds: [], // BDC dont l'état local n'est plus fiable pour le bouton
    };
  },
  computed: {
    // Garde-fou UI : le bouton "Envoyer en corbeille" reste grisé tant que
    // l'opérateur n'a pas tapé "SUPPRIMER" en majuscules dans le champ de confirmation.
    canConfirmDelete() {
      return this.deleteConfirmText === "SUPPRIMER";
    },
    // Garde-fou UI corbeille : bouton "Vider" grisé tant que VIDER n'est pas tapé
    canConfirmEmptyTrash() {
      return this.emptyTrashConfirmText === "VIDER";
    },
    isTrashTab() {
      return this.currentTab === "deleted";
    },
    // visibilité décidée par le backend, plus le garde-fou corbeille
    // un BDC verrouillé le reste tant que la liste ne confirme pas son état
    canAddBdc() {
      if (!this.selectedItem || this.isTrashTab) return false;
      if (this.lockedBdcIds.includes(this.selectedItem.id)) return false;
      return this.selectedItem.canUploadSignedBdc === true;
    },
    hasBdcPdf() {
      return !!(
        this.selectedItem &&
        this.selectedItem.files &&
        this.selectedItem.files.orderFormPDF
      );
    },
    // Validation legere de l'email (même regex que côté serveur)
    isValidResendEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.resendEmailInput || "");
    },
    // Checkbox "Sauvegarder en base" desactivee si email invalide ou identique a
    // celui deja stocke sur le resident : evite de proposer un update no-op.
    canUpdateResidentEmail() {
      if (!this.isValidResendEmail) return false;
      const current = (this.selectedItem?.resident?.email || "")
        .trim()
        .toLowerCase();
      const next = (this.resendEmailInput || "").trim().toLowerCase();
      return current !== next;
    },
    tabDefs() {
      return [
        { key: "all", label: "Tous" },
        { key: "enCours", label: "En cours" },
        { key: "soumisAsp", label: "Soumis ASP" },
        { key: "rejetes", label: "Rejetés" },
        { key: "va", label: "VA" },
        { key: "pilots", label: "Pilotes" },
        { key: "mustResign", label: "À re-signer" },
        { key: "awaitingFirstSign", label: "En attente signature" },
        { key: "ps", label: "Prest. Secondaire" },
        { key: "deleted", label: "Corbeille" },
      ];
    },
    pageCount() {
      return Math.ceil(this.totalCount / PAGE_SIZE) || 1;
    },

    // libellé du périmètre couvert par le bandeau, qui suit l'onglet et les filtres
    scopeLabel() {
      const tab = this.tabDefs.find((t) => t.key === this.appliedTab);
      const onglet = tab ? tab.label.toLowerCase() : "tous";
      const base = `Sélection courante : ${onglet}`;
      if (!this.filtersApplied) return `${base}, sans filtre`;
      return `${base}, ${this.appliedFilterCount} filtre${
        this.appliedFilterCount > 1 ? "s" : ""
      }`;
    },

    // référence grise, null quand elle vaudrait la valeur courante
    statsRef() {
      return this.filtersApplied && this.scope ? this.scope : null;
    },

    sharePercent() {
      if (!this.statsRef) return "";
      const total = Number(this.statsRef.totalPPHT) || 0;
      if (total <= 0) return "";
      const part = (Number(this.stats.totalPPHT) / total) * 100;
      return ` (${part.toFixed(1)} %)`;
    },

    averageHT() {
      if (!this.stats || !this.stats.bdcTotal) return "0.00";
      return (Number(this.stats.totalPPHT) / this.stats.bdcTotal).toFixed(2);
    },

    // filtres actifs, affichés en puces retirables au-dessus du tableau
    activeFilterChips() {
      const chips = [];
      if (this.query) {
        chips.push({ key: "query", label: `Recherche : ${this.query}` });
      }
      if (this.emailStatusFilter !== "Tous") {
        chips.push({
          key: "emailStatusFilter",
          label: `Email : ${this.emailStatusFilter}`,
        });
      }
      if (this.partyType !== "all") {
        const option = this.partyTypeOptions.find(
          (o) => o.value === this.partyType
        );
        chips.push({
          key: "partyType",
          label: `Structure : ${option ? option.text : this.partyType}`,
        });
      }
      if (this.typePrestation !== "all") {
        chips.push({
          key: "typePrestation",
          label: `Prestation : ${this.typePrestation}`,
        });
      }
      if (this.tranche !== "all") {
        const option = this.trancheOptions.find(
          (o) => o.value === this.tranche
        );
        chips.push({
          key: "tranche",
          label: `Tranche : ${option ? option.text : this.tranche}`,
        });
      }
      if (this.pilot !== "all") {
        chips.push({
          key: "pilot",
          label: this.pilot === "yes" ? "Pilotes" : "Hors pilotes",
        });
      }
      if (this.signedFrom || this.signedTo) {
        chips.push({ key: "period", label: `Signé ${this.periodLabel}` });
      }
      return chips;
    },

    // libellé lisible de la période
    periodLabel() {
      if (this.signedFrom && this.signedTo) {
        return `du ${this.frDate(this.signedFrom)} au ${this.frDate(
          this.signedTo
        )}`;
      }
      if (this.signedFrom) return `depuis le ${this.frDate(this.signedFrom)}`;
      if (this.signedTo) return `jusqu'au ${this.frDate(this.signedTo)}`;
      return "";
    },

    // le backend neutralise les deux bornes sur un intervalle inversé
    periodInvalid() {
      return !!(
        this.signedFrom &&
        this.signedTo &&
        this.signedFrom > this.signedTo
      );
    },

    periodShortcuts() {
      return [
        { key: "today", label: "Aujourd'hui" },
        { key: "7d", label: "7 jours" },
        { key: "30d", label: "30 jours" },
        { key: "month", label: "Mois en cours" },
        { key: "year", label: "Année" },
      ];
    },
  },
  watch: {
    currentTab() {
      this.lockedBdcIds = [];
      // le bandeau suit l'onglet, les statistiques sont donc rechargées
      this.reload({ resetPage: true });
    },
    query() {
      // sans cette garde, la remise à vide de clearSearch relancerait un chargement
      if (this.skipQueryWatch) {
        this.skipQueryWatch = false;
        return;
      }
      // sans debounce, chaque frappe déclencherait listing, badges et agrégats
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;
        this.search();
      }, SEARCH_DEBOUNCE_MS);
    },
  },
  async created() {
    await this.reload();
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  methods: {
    // point d'entrée unique de chargement
    async reload({ withStats = true, resetPage = false } = {}) {
      if (resetPage) this.page = 1;

      // l'onglet PS a son propre tableau, mais ses badges suivent les filtres
      const isPs = this.currentTab === "ps";

      // redemander les chiffres dès qu'ils ne correspondent plus au périmètre courant
      const perimetre = this.perimeterKey();
      const wantStats =
        !isPs && (withStats || this.appliedStatsKey !== perimetre);

      const mySeq = ++this.reqSeq;
      if (wantStats) this.statsLoading = true;

      try {
        const [list, ps] = await Promise.all([
          this.requestOrderForms(wantStats),
          isPs ? this.requestPS() : Promise.resolve(null),
        ]);

        // une requête plus récente est partie entre-temps, celle-ci n'a plus cours
        if (mySeq !== this.reqSeq) return false;

        if (!list) {
          // bandeau marqué périmé
          if (wantStats) this.statsStale = true;
          return false;
        }

        this.rows = list.rows;
        this.totalCount = list.count;
        // une erreur de chargement PS ne doit pas se lire comme un onglet vide
        this.psError = isPs && ps === null;
        this.tabCounts = {
          ...list.tabs,
          ps: Array.isArray(ps) ? ps.length : undefined,
        };
        this.searchTruncated = !!list.searchTruncated;
        if (typeof list.trashTtlDays === "number") {
          this.trashTtlDays = list.trashTtlDays;
        }
        this.trashTotal = list.trashTotal ?? list.tabs.deleted ?? 0;
        this.filtersApplied = !!list.filtersApplied;
        // le libellé du bandeau décrit les chiffres affichés (pas la sélection en cours)
        this.appliedTab = this.currentTab;
        this.appliedFilterCount = this.activeFilterChips.length;
        if (isPs && Array.isArray(ps)) this.psRows = ps;
        if (wantStats) {
          this.stats = list.stats;
          this.scope = list.scope;
          this.statsStale = false;
          this.appliedStatsKey = perimetre;
        }
        return true;
      } finally {
        // la dernière requête solde l'indicateur, qu'elle porte les statistiques ou non
        if (mySeq === this.reqSeq) this.statsLoading = false;
      }
    },

    // périmètre des chiffres du bandeau, hors tri et pagination qui ne changent que l'ordre
    perimeterKey() {
      const f = this.buildFilterPayload();
      return JSON.stringify([
        f.tab,
        f.search,
        f.emailStatus,
        f.partyType,
        f.typePrestation,
        f.tranche,
        f.pilot,
        f.signedFrom,
        f.signedTo,
      ]);
    },

    // changer de page ne change pas le périmètre
    onPageChange(value) {
      this.page = value;
      this.reload({ withStats: false });
    },

    // le tri ne change pas le périmètre non plus
    applySort() {
      this.reload({ withStats: false, resetPage: true });
    },

    // filtres et tri communs au listing et à l'export, une seule définition
    buildFilterPayload() {
      const emailStatusMap = {
        Tous: null,
        Envoyé: "SENT",
        Échec: "FAILED",
        "En cours": "PENDING",
        "Non suivi": "NONE",
      };
      const sortMap = {
        "N° Éditeur": "numeroEditeur",
        "N° ASP": "numeroASP",
        Montant: "montant",
        Date: "date",
        État: "state",
      };
      // sortBy omis au défaut sur l'onglet À re-signer, le serveur teste sortBy === undefined
      const sortByDefault = this.sortBy === "N° Éditeur";
      const sortBy =
        this.currentTab === "mustResign" && sortByDefault
          ? undefined
          : sortMap[this.sortBy] || "numeroEditeur";
      return {
        tab: this.currentTab,
        search: this.query,
        sortBy,
        sortOrder: this.sortOrder === "Croissant" ? "ASC" : "DESC",
        emailStatus: emailStatusMap[this.emailStatusFilter] || null,
        partyType: this.partyType,
        typePrestation: this.typePrestation,
        tranche: this.tranche,
        pilot: this.pilot,
        signedFrom: this.signedFrom || null,
        signedTo: this.signedTo || null,
      };
    },

    // requête de listing sans effet sur l'état, reload applique le résultat
    async requestOrderForms(withStats) {
      try {
        const res = await axios.post(
          `${API_BASE}/segur/v2/orderforms`,
          {
            ...this.buildFilterPayload(),
            offset: (this.page - 1) * PAGE_SIZE,
            limit: PAGE_SIZE,
            withStats,
          },
          { headers: server.getHeader() }
        );
        return res.data && res.data.success ? res.data.data : null;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur listing:", err.message);
        return null;
      }
    },

    async requestPS() {
      try {
        const res = await axios.post(
          `${API_BASE}/segur/v2/prestations-secondaires`,
          this.buildFilterPayload(),
          { headers: server.getHeader() }
        );
        return res.data && res.data.success ? res.data.data : null;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur PS:", err.message);
        return null;
      }
    },

    async downloadPdf(type, id) {
      try {
        // Onglet Corbeille : header explicite pour autoriser le download d'un PDF
        // dont le parent est en corbeille (sinon le backend renvoie 404).
        const headers = { ...server.getHeader() };
        if (this.currentTab === "deleted") {
          headers["X-Trash-Context"] = "true";
        }
        const res = await axios.get(
          `${API_BASE}/segur/download/${type}/${id}`,
          { headers, responseType: "blob" }
        );
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${type}-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[Segur] Erreur téléchargement PDF:", err.message);
      }
    },

    // --- Ajout d'un BDC papier signé -------------------------------------

    // reset de value avant ouverture, sinon re-choisir le même fichier ne déclenche pas change
    triggerBdcFilePicker() {
      if (this.uploadingBdc) return;
      this.bdcUploadFeedback = null;
      // bdcConfirmError garde sa valeur, sinon le bouton « Choisir un autre
      // fichier » disparaît sous le clic
      const input = this.$refs.bdcFileInput;
      if (!input) return;
      input.value = "";
      input.click();
    },

    onBdcFileSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      // reset immédiat, l'input ne doit garder aucune sélection
      input.value = "";
      if (!file) return; // boîte système annulée

      const error = this.validateBdcFile(file);
      if (error) {
        if (this.showBdcUploadConfirm) this.bdcConfirmError = error;
        else this.bdcUploadFeedback = { success: false, message: error };
        return;
      }

      // re-choix après refus, la cible reste celle du premier passage
      if (this.showBdcUploadConfirm && this.pendingBdcTarget) {
        this.pendingBdcFile = file;
        this.bdcConfirmError = null;
        return;
      }
      if (!this.selectedItem) return;

      this.pendingBdcTarget = {
        id: this.selectedItem.id,
        numeroEditeur: this.selectedItem.numeroEditeur,
        label: this.bdcTargetLabel(this.selectedItem),
        hadPdf: this.hasBdcPdf,
      };
      this.pendingBdcFile = file;
      this.bdcConfirmError = null;
      this.showBdcUploadConfirm = true;
    },

    bdcTargetLabel(item) {
      if (!item) return "";
      if (item.msp) {
        return [item.msp.FINESS, item.msp.raisonSociale]
          .filter(Boolean)
          .join(" - ");
      }
      if (item.resident) {
        return [item.resident["prénom"], item.resident.nom]
          .filter(Boolean)
          .join(" ");
      }
      return "";
    },

    // le navigateur dérive le type de l'extension, un fichier renommé .pdf
    // passe ici et sera refusé en 400 par le serveur
    validateBdcFile(file) {
      const isPdf =
        file.type === "application/pdf" || /\.pdf$/i.test(file.name || "");
      if (!isPdf) {
        return `« ${file.name} » n'est pas un PDF. Sélectionnez un fichier .pdf.`;
      }
      if (file.size === 0) {
        return `« ${file.name} » est vide.`;
      }
      if (file.size > MAX_BDC_PDF_SIZE) {
        const mb = (file.size / (1024 * 1024)).toFixed(1);
        return `« ${file.name} » fait ${mb} Mo : le fichier ne doit pas dépasser 3 Mo.`;
      }
      return null;
    },

    closeBdcConfirm() {
      this.showBdcUploadConfirm = false;
      this.pendingBdcFile = null;
      this.pendingBdcTarget = null;
      this.bdcConfirmError = null;
    },

    cancelBdcUpload() {
      if (this.uploadingBdc) return;
      this.closeBdcConfirm();
    },

    confirmBdcUpload() {
      if (this.uploadingBdc) return;
      this.uploadBdcPdf();
    },

    // 400 = problème de fichier, la confirmation reste ouverte pour en choisir un autre
    // toute autre erreur est terminale pour cette cible
    async uploadBdcPdf() {
      if (this.uploadingBdc || !this.pendingBdcTarget || !this.pendingBdcFile) {
        return;
      }
      const target = this.pendingBdcTarget;
      const file = this.pendingBdcFile;
      this.uploadingBdc = true;
      this.bdcConfirmError = null;

      let pdf;
      try {
        pdf = await this.fileToBase64(file);
      } catch (err) {
        // échec de lecture locale (fichier retiré, permission refusée), pas une erreur réseau
        this.bdcConfirmError = `Lecture de « ${file.name} » impossible. Sélectionnez à nouveau le fichier.`;
        this.uploadingBdc = false;
        return;
      }

      try {
        await axios.post(
          `${this.apiBase}/segur/createorderformpdf`,
          {
            obj: {
              pdf,
              numeroEditeur: target.numeroEditeur,
              orderFormId: target.id,
            },
          },
          { headers: server.getHeader() }
        );
        this.lockedBdcIds = [...this.lockedBdcIds, target.id];
        this.closeBdcConfirm();
        this.setBdcFeedback(target.id, {
          success: true,
          message: `BDC signé ajouté (${file.name}). Le BDC passe à l'état Signé.`,
        });
        await this.refreshAfterBdcUpload(target.id, true);
      } catch (err) {
        const message = this.bdcUploadErrorMessage(err);
        const status = err.response && err.response.status;
        if (status === 400) {
          this.bdcConfirmError = message;
        } else {
          // sur 404 et 409 la cible n'est plus éligible
          // verrouiller sans attendre le rafraîchissement, qui peut échouer
          if (status === 404 || status === 409) {
            this.lockedBdcIds = [...this.lockedBdcIds, target.id];
          }
          this.closeBdcConfirm();
          this.setBdcFeedback(target.id, { success: false, message });
          await this.refreshAfterBdcUpload(target.id, false);
        }
      } finally {
        this.uploadingBdc = false;
      }
    },

    // un retour asynchrone ne doit pas s'afficher sur une autre entité
    setBdcFeedback(id, feedback) {
      if (this.selectedItem && this.selectedItem.id === id) {
        this.bdcUploadFeedback = feedback;
      }
    },

    appendBdcFeedbackNote(note) {
      const current = this.bdcUploadFeedback || { success: true, message: "" };
      this.bdcUploadFeedback = {
        ...current,
        message: `${current.message} ${note}`.trim(),
      };
    },

    // reload remplace rows, selectedItem doit être ré-associé par id
    // et seulement si la liste a été rechargée
    async refreshAfterBdcUpload(id, uploaded) {
      const listOk = await this.reload();
      if (!this.selectedItem || this.selectedItem.id !== id) return;

      if (!listOk) {
        this.appendBdcFeedbackNote(
          "Liste non actualisée : rafraîchissez la page pour voir l'état à jour."
        );
        return;
      }

      const fresh = this.rows.find((r) => r.id === id);
      if (fresh) {
        this.selectedItem = fresh;
        if (fresh.canUploadSignedBdc === false) {
          this.lockedBdcIds = this.lockedBdcIds.filter((x) => x !== id);
        }
        return;
      }
      this.appendBdcFeedbackNote(
        uploaded
          ? "Ligne sortie de la page courante : rafraîchissez la liste pour la retrouver."
          : "Ce BDC n'apparaît plus dans la liste. Fermez la modale et rafraîchissez."
      );
    },

    // base64 sans le préfixe data:, comme Segurbon.vue
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result).split(",")[1]);
        reader.onerror = () =>
          reject(reader.error || new Error("Lecture du fichier impossible"));
        reader.readAsDataURL(file);
      });
    },

    // formats d'erreur : Ségur {data:{error}}, forbiddenAccess {data:{msg}}, multi-tenant {error}
    bdcUploadErrorMessage(err) {
      const status = err.response && err.response.status;
      const payload = err.response && err.response.data;
      const serverMsg =
        (payload && payload.data && (payload.data.error || payload.data.msg)) ||
        (payload && (payload.error || payload.message));

      if (!err.response) {
        return "Serveur injoignable. Vérifiez votre connexion puis réessayez.";
      }
      if (status === 400) {
        return (
          serverMsg || "Requête invalide : fichier ou n° éditeur manquant."
        );
      }
      if (status === 404) {
        return "BDC introuvable côté serveur (supprimé ou mis en corbeille ?). Rafraîchissez la liste.";
      }
      if (status === 409) {
        return (
          serverMsg || "Ajout impossible : l'état du BDC a changé entre-temps."
        );
      }
      if (status === 413) {
        return "Fichier trop volumineux pour le serveur.";
      }
      if (status === 401 || status === 403) {
        return "Session expirée ou droits insuffisants (droit segur requis).";
      }
      if (status >= 500) {
        return `Erreur serveur : ${serverMsg || err.message}`;
      }
      return serverMsg || err.message || "Erreur lors de l'ajout du BDC.";
    },

    // un badge à 0 reste affiché sous filtre
    showBadge(key) {
      if (this.tabCounts[key]) return true;
      return this.filtersApplied && typeof this.tabCounts[key] === "number";
    },

    // référence masquée quand elle vaut la valeur courante, "0 sur 0" n'apprend rien
    refFor(key) {
      if (!this.statsRef) return false;
      return this.statsRef[key] !== this.stats[key];
    },

    // retire un filtre depuis sa puce, mêmes valeurs de reset que clearSearch
    removeFilter(key) {
      if (key === "query") {
        if (this.query !== "") this.skipQueryWatch = true;
        this.query = "";
      }
      if (key === "emailStatusFilter") this.emailStatusFilter = "Tous";
      if (key === "partyType") this.partyType = "all";
      if (key === "typePrestation") this.typePrestation = "all";
      if (key === "tranche") this.tranche = "all";
      if (key === "pilot") this.pilot = "all";
      if (key === "period") {
        this.signedFrom = null;
        this.signedTo = null;
      }
      this.reload({ resetPage: true });
    },

    // date ISO locale, toISOString basculerait en UTC et pourrait reculer d'un jour
    isoDate(date) {
      const p = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(
        date.getDate()
      )}`;
    },

    frDate(iso) {
      if (!iso) return "";
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y}`;
    },

    applyPeriodShortcut(key) {
      const today = new Date();
      const from = new Date(today);
      if (key === "7d") from.setDate(from.getDate() - 6);
      if (key === "30d") from.setDate(from.getDate() - 29);
      if (key === "month") from.setDate(1);
      if (key === "year") {
        from.setMonth(0);
        from.setDate(1);
      }
      this.signedFrom = this.isoDate(from);
      this.signedTo = this.isoDate(today);
      this.applyPeriod();
    },

    applyPeriod() {
      if (this.periodInvalid) return;
      this.dateMenu = false;
      this.reload({ resetPage: true });
    },

    clearPeriod() {
      this.signedFrom = null;
      this.signedTo = null;
      this.dateMenu = false;
      this.reload({ resetPage: true });
    },

    // exporte le périmètre affiché, mêmes filtres et même tri
    async exportView() {
      if (this.exporting) return;
      this.exporting = true;
      try {
        const res = await axios.post(
          `${API_BASE}/segur/v2/orderforms/export`,
          this.buildFilterPayload(),
          { headers: server.getHeader(), responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `SEGUR-liste-${this.currentTab}-${this.isoDate(new Date())}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        // la réponse d'erreur est un blob, la relire en texte pour afficher le motif
        let message = err.message;
        try {
          if (err.response?.data instanceof Blob) {
            const parsed = JSON.parse(await err.response.data.text());
            message = parsed?.data?.error || message;
          }
        } catch {
          // blob illisible, message d'origine conservé
        }
        alert(`Export impossible : ${message}`);
      } finally {
        this.exporting = false;
      }
    },

    search() {
      // entrée ou bouton Rechercher, on n'attend pas la fin du debounce
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.reload({ resetPage: true });
    },

    clearSearch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      if (this.query !== "") this.skipQueryWatch = true;
      this.query = "";
      this.emailStatusFilter = "Tous";
      this.partyType = "all";
      this.typePrestation = "all";
      this.tranche = "all";
      this.pilot = "all";
      this.signedFrom = null;
      this.signedTo = null;
      this.sortBy = "N° Éditeur";
      this.sortOrder = "Décroissant";
      this.reload({ resetPage: true });
    },

    mspTooltip(msp) {
      if (!msp) return "";
      const parts = [];
      if (msp.FINESSGEO) parts.push("FINESS GEO : " + msp.FINESSGEO);
      if (msp.raisonSociale) parts.push(msp.raisonSociale);
      if (msp.partnerRef) parts.push("Réf : " + msp.partnerRef);
      return parts.join(" - ");
    },

    openDetail(item) {
      this.selectedItem = item;
      this.bdcUploadFeedback = null;
      this.closeBdcConfirm();
      this.dialog = true;
    },

    getDate(d) {
      if (!d) return "";
      const date = new Date(d);
      return (
        ("0" + date.getDate()).slice(-2) +
        "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        date.getFullYear()
      );
    },

    stateLabel(state) {
      if (state === "ON") return "Terminé";
      if (state === "ENABLE") return "Signé";
      if (state === "OFF") return "Non signé";
      if (state === "DISABLE") return "Désactivé";
      return state;
    },

    stateColor(state) {
      if (state === "ON") return "green";
      if (state === "ENABLE") return "orange";
      if (state === "DISABLE") return "grey";
      return "red";
    },

    typeColor(type) {
      if (type === "V2") return "blue";
      if (type === "V1V2") return "orange";
      return "grey";
    },

    psColor(status) {
      if (status === "APPROVED") return "green";
      if (status === "READY") return "blue";
      if (status === "MONITORING") return "orange";
      if (status === "REJECTED") return "red";
      return "grey";
    },

    pilotColor(status) {
      if (status === "VALIDATED") return "green";
      if (status === "SUBMITTED") return "orange";
      if (status === "REJECTED") return "red";
      return "purple";
    },

    pilotLabel(status) {
      if (status === "VALIDATED") return "Validé";
      if (status === "SUBMITTED") return "Soumis";
      if (status === "REJECTED") return "Rejeté";
      return "Pilote";
    },

    // Statut email BDC : SENT/FAILED/PENDING/null (BDC pre-migration)
    emailStatusColor(status) {
      if (status === "SENT") return "green";
      if (status === "FAILED") return "red";
      if (status === "PENDING") return "grey";
      return "grey lighten-1";
    },

    emailStatusLabel(status) {
      if (status === "SENT") return "Envoyé";
      if (status === "FAILED") return "Échec";
      if (status === "PENDING") return "Envoi en cours";
      return "Non suivi";
    },

    openResendEmailDialog(item) {
      // Pre-remplit avec l'email du resident (déjà dans le payload listing V2)
      this.resendEmailInput = item?.resident?.email || "";
      this.resendEmailFeedback = null;
      this.resendEmailUpdateResident = false;
      this.showResendEmailDialog = true;
    },

    closeResendEmailDialog() {
      this.showResendEmailDialog = false;
      this.resendEmailInput = "";
      this.resendEmailFeedback = null;
      this.resendEmailUpdateResident = false;
    },

    async confirmResendEmail() {
      if (!this.selectedItem || !this.isValidResendEmail) return;
      this.resendEmailLoading = true;
      this.resendEmailFeedback = null;
      // Snapshot du flag combine avec canUpdateResidentEmail : si la checkbox est
      // restee cochee mais que l'email a ete remis a celui du resident, on n'envoie
      // pas updateResidentEmail=true (la checkbox est desactivee mais le model garde
      // sa valeur).
      const wantedUpdate =
        this.resendEmailUpdateResident && this.canUpdateResidentEmail;
      try {
        const response = await axios.post(
          `${this.apiBase}/segur/v2/orderforms/${this.selectedItem.id}/resend-email`,
          { email: this.resendEmailInput, updateResidentEmail: wantedUpdate },
          { headers: server.getHeader() }
        );
        // Response.success(res, data) => { success: true, data: {...} }
        const payload = response.data?.data || {};
        const updated = payload.residentEmailUpdated === true;
        const updateError = payload.residentUpdateError || null;
        // emailSentTo vient du backend deja trime ; fallback sur le saisi trime
        const sentTo =
          payload.emailSentTo || (this.resendEmailInput || "").trim();

        // Met a jour le selectedItem en local pour rafraichir le badge sans reload
        if (this.selectedItem) {
          this.selectedItem.emailStatus = "SENT";
          this.selectedItem.emailError = null;
          if (updated && this.selectedItem.resident) {
            this.selectedItem.resident.email = sentTo;
          }
        }

        let message = `Email envoyé avec succès à ${sentTo}.`;
        if (wantedUpdate) {
          if (updated) {
            message += " Adresse du résident mise à jour en base.";
          } else if (updateError) {
            message += ` Attention : adresse non mise à jour en base (${updateError}).`;
          }
          // Sinon : flag coche mais updated=false sans error => no-op
          // (adresse identique apres normalisation), pas de mention necessaire.
        }
        this.resendEmailFeedback = { success: true, message };

        // Refresh listing pour synchroniser les autres lignes/onglets
        await this.reload();
        // Ferme après un petit délai pour laisser voir le message de succes
        setTimeout(() => this.closeResendEmailDialog(), 1200);
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        this.resendEmailFeedback = {
          success: false,
          message: `Échec : ${msg}`,
        };
        // Le backend a déjà persiste emailStatus = FAILED avant le 502 :
        // refletter ca dans l'UI pour que le badge ne reste pas obsolete jusqu'au
        // prochain refresh manuel.
        if (this.selectedItem) {
          this.selectedItem.emailStatus = "FAILED";
          this.selectedItem.emailError = msg;
        }
        await this.reload();
      } finally {
        this.resendEmailLoading = false;
      }
    },

    async togglePilot(item, isPilot) {
      try {
        await axios.patch(
          `${this.apiBase}/segur/v2/orderforms/${item.id}/pilot`,
          { isPilot },
          { headers: server.getHeader() }
        );
        this.dialog = false;
        this.reload();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(msg);
      }
    },

    async updatePilotStatus(item, pilotStatus) {
      try {
        await axios.patch(
          `${this.apiBase}/segur/v2/orderforms/${item.id}/pilot-status`,
          { pilotStatus },
          { headers: server.getHeader() }
        );
        this.dialog = false;
        this.reload();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(msg);
      }
    },

    // Annulation du dialog de suppression : reset du champ de confirmation
    cancelDeleteBDC() {
      this.showDeleteConfirmDialog = false;
      this.deleteConfirmText = "";
    },

    // Mise en corbeille du BDC (récupérable pendant trashTtlDays jours)
    // Garde-fou UI : l'opérateur doit taper "SUPPRIMER" pour dégriser le bouton
    async confirmDeleteBDC() {
      if (!this.selectedItem) return;
      if (this.deleteConfirmText !== "SUPPRIMER") return;
      try {
        await axios.delete(
          `${this.apiBase}/segur/v2/orderforms/${this.selectedItem.id}`,
          { headers: server.getHeader() }
        );
        this.showDeleteConfirmDialog = false;
        this.deleteConfirmText = "";
        this.dialog = false;
        this.selectedItem = null;
        await this.reload();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(`Erreur lors de la mise en corbeille : ${msg}`);
      }
    },

    // --- Corbeille SEGUR V2 -----------------------------------------------

    // Couleur du badge "Purge dans X j" selon proximite TTL
    purgeColor(purgeScheduledAt) {
      if (!purgeScheduledAt) return "grey";
      const days = Math.ceil(
        (new Date(purgeScheduledAt).getTime() - Date.now()) / 86400000
      );
      if (days <= 0) return "red darken-2";
      if (days <= 7) return "red";
      if (days <= 14) return "orange";
      return "grey";
    },

    purgeLabel(purgeScheduledAt) {
      if (!purgeScheduledAt) return "";
      const days = Math.ceil(
        (new Date(purgeScheduledAt).getTime() - Date.now()) / 86400000
      );
      if (days <= 0) return "Purge imminente";
      if (days === 1) return "Purge dans 1 j";
      return `Purge dans ${days} j`;
    },

    async restoreBDC(item) {
      if (!item) return;
      try {
        await axios.post(
          `${this.apiBase}/segur/v2/orderforms/${item.id}/restore`,
          {},
          { headers: server.getHeader() }
        );
        this.dialog = false;
        this.selectedItem = null;
        await this.reload();
      } catch (err) {
        // 409 RESTORE_CONFLICT : le backend a détecté un BDC actif concurrent
        if (
          err.response?.status === 409 &&
          err.response?.data?.errorCode === "RESTORE_CONFLICT"
        ) {
          this.restoreConflict = err.response.data.conflictWith;
          this.restoreConflictFor = item;
          return;
        }
        // 410 Gone : TTL expirée
        if (err.response?.status === 410) {
          alert(
            "Ce BDC ne peut plus être restaure (délai expirée). Il sera purge définitivement par le cron."
          );
          await this.reload();
          return;
        }
        const msg = err.response?.data?.error || err.message;
        alert(`Erreur lors de la restauration : ${msg}`);
      }
    },

    async confirmRestoreSwap() {
      if (!this.restoreConflictFor || !this.restoreConflict) return;
      try {
        await axios.post(
          `${this.apiBase}/segur/v2/orderforms/${this.restoreConflictFor.id}/restore-swap`,
          { swapWithId: this.restoreConflict.id },
          { headers: server.getHeader() }
        );
        this.restoreConflict = null;
        this.restoreConflictFor = null;
        this.dialog = false;
        this.selectedItem = null;
        await this.reload();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(`Échange impossible : ${msg}`);
      }
    },

    cancelRestoreSwap() {
      this.restoreConflict = null;
      this.restoreConflictFor = null;
    },

    openEmptyTrashDialog() {
      this.emptyTrashConfirmText = "";
      this.showEmptyTrashDialog = true;
    },

    cancelEmptyTrash() {
      this.showEmptyTrashDialog = false;
      this.emptyTrashConfirmText = "";
    },

    async confirmEmptyTrash() {
      if (this.emptyTrashConfirmText !== "VIDER") return;
      try {
        await axios.post(
          `${this.apiBase}/segur/v2/orderforms/trash/empty`,
          { confirm: "VIDER" },
          { headers: server.getHeader() }
        );
        this.showEmptyTrashDialog = false;
        this.emptyTrashConfirmText = "";
        await this.reload();
      } catch (err) {
        const msg = err.response?.data?.error || err.message;
        alert(`Erreur lors du vidage de la corbeille : ${msg}`);
      }
    },

    enterEditMode() {
      this.editMode = true;
    },

    cancelEditMode() {
      this.editMode = false;
      this.pendingDiff = {};
      this.pendingResignReason = "";
    },

    closeDetailDialog() {
      if (this.editMode) {
        const confirmed = window.confirm(
          "Édition en cours. Fermer abandonne les modifications. Continuer ?"
        );
        if (!confirmed) return;
      }
      this.editMode = false;
      this.pendingDiff = {};
      this.pendingResignReason = "";
      this.dialog = false;
    },

    onDialogToggle(open) {
      if (!open) {
        this.editMode = false;
        this.pendingDiff = {};
        this.pendingResignReason = "";
        this.bdcUploadFeedback = null;
        this.closeBdcConfirm();
      }
    },

    onEditableSave(diff) {
      if (!diff || Object.keys(diff).length === 0) return;
      this.pendingDiff = diff;
      // Reset systématique du motif à chaque ouverture pour éviter de réutiliser
      // un motif d'un précédent PATCH.
      this.pendingResignReason = "";
      this.showConfirmResign = true;
    },

    cancelPatch() {
      this.showConfirmResign = false;
      this.pendingResignReason = "";
    },

    async confirmPatch() {
      if (!this.selectedItem || !this.pendingDiff || this.patchLoading) return;
      this.patchLoading = true;
      try {
        // Le motif est toujours envoyé (même vide) pour écraser l'éventuel
        // motif persisté lors d'un PATCH précédent.
        const payload = {
          ...this.pendingDiff,
          resignReason: (this.pendingResignReason || "").trim(),
        };
        const res = await axios.patch(
          `${this.apiBase}/segur/v2/orderforms/${this.selectedItem.id}`,
          payload,
          { headers: server.getHeader() }
        );
        const result = res.data?.data || {};
        const updated = Array.isArray(result.updated) ? result.updated : [];
        const tablesMsg = updated.length > 0 ? ` (${updated.join(", ")})` : "";
        this.$toast
          ? this.$toast(`BDC mis à jour${tablesMsg}. Le médecin sera notifié.`)
          : alert(`BDC mis à jour${tablesMsg}. Le médecin sera notifié.`);
        this.showConfirmResign = false;
        this.pendingDiff = {};
        this.pendingResignReason = "";
        this.editMode = false;
        this.dialog = false;
        this.selectedItem = null;
        await this.reload();
      } catch (err) {
        const status = err.response?.status;
        const data = err.response?.data;
        if (status === 400 && data?.data?.details) {
          const lines = data.data.details
            .map((d) => `- ${d.path} : ${d.message}`)
            .join("\n");
          alert(`Payload invalide :\n${lines}`);
        } else if (status === 404) {
          alert("BDC introuvable");
        } else if (status === 400) {
          alert(data?.error || data?.data?.error || "Requête invalide");
        } else {
          alert(`Erreur : ${data?.error || err.message}`);
        }
      } finally {
        this.patchLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* la ligne du haut porte un texte d'aide sur deux lignes, d'où la marge */
.filters-row-2 {
  margin-top: 22px;
}

.period-card {
  padding: 16px;
}

.ps-error {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #c62828;
  padding: 10px 8px;
}

.period-shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 22px;
}

.period-shortcuts .v-btn {
  letter-spacing: 0.4px;
}

.period-error {
  font-size: 11px;
  color: #c62828;
}

.search-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 8px;
}

.search-actions-side {
  flex: 1;
  display: flex;
  min-width: 0;
}

.search-actions-right {
  justify-content: flex-end;
}

/* la classe globale researcheButton porte des marges négatives, inutilisables en flex */
.search-submit {
  width: 220px;
  margin: 0;
  flex-shrink: 0;
}

.tab-badge {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  margin-left: 6px;
}

.tab-badge-empty {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.65);
}

.stats-scope {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #888;
  margin-bottom: 8px;
}

.stats-stale {
  color: #c62828;
  margin-left: 8px;
}

.stats-truncated {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #c62828;
  padding: 8px 0;
}

.stat-ref {
  font-size: 11px;
  color: #999;
  margin-left: 4px;
}

.stat-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.stat-average {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}

.active-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 8px;
}

.active-filter-chip {
  font-size: 11px;
}

.content {
  max-width: 100%;
  padding: 0;
}

/* Tous les blocs alignes sur la même largeur */
.content > .v-card,
.content > .md-card,
.content > .v-tabs,
.content > .v-tabs-items {
  margin-left: 0;
  margin-right: 0;
}

/* Tableau pleine largeur */
.md-table {
  width: 100%;
}

.md-table .md-table-cell {
  white-space: nowrap;
  font-size: 13px;
  padding: 4px 8px;
}

/* Chips plus compacts */
.v-chip.v-size--x-small {
  font-size: 11px;
  height: 20px;
}

/* Tabs filtres : texte blanc, actif en blanc gras (pas de bleu) */
.v-tabs .v-tab {
  color: rgba(255, 255, 255, 0.7) !important;
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 0.5px;
}
.v-tabs .v-tab--active {
  color: #fff !important;
  font-weight: bold;
}
</style>
